/* -----------------Child components--------------- */
import DocumentTitle from "components/DocumentTitle";

import { events } from "@constants/tracking";
import { pageViewTypes } from "@constants/tracking";
/* -----------------Types--------------- */
import { ProethicaTestReport, ReportContainer } from "@features/report";
import { useSessionStore } from "@features/session";
import { BottomSheetModalProvider } from "@gorhom/bottom-sheet";
import useAnalytics from "@hooks/useAnalytics";

const ReportRoute = () => {
	useAnalytics({
		type: pageViewTypes.report,
		eventName: events.reportViewed,
	});

	const isProethicaTest = useSessionStore(
		(state) => state.proethicaTestKind != null,
	);

	return (
		<>
			<BottomSheetModalProvider>
				<DocumentTitle title={"Report"} />
				{isProethicaTest ? <ProethicaTestReport /> : <ReportContainer />}
			</BottomSheetModalProvider>
		</>
	);
};

export default ReportRoute;
